import { render, staticRenderFns } from "./SelectedProducts.vue?vue&type=template&id=cf7ad106"
import script from "./SelectedProducts.vue?vue&type=script&lang=js"
export * from "./SelectedProducts.vue?vue&type=script&lang=js"
import style0 from "./SelectedProducts.vue?vue&type=style&index=0&id=cf7ad106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports